<template>
  <div class="product">
    <div class="container">
      <div class="bg white pl-3 pr-3 pb-4">
        <div class="row">
          <div class="col-3 d-none d-md-block">
            <ProductCategory/>
          </div>
          <div class="product-list col">
            <ProductOption :navOption="navOption"/>
            <div class="product-list__list pt-3 bg white">
              <div v-if="!loading" class="row">
                <div
                  @click="detailItem(product,$event)"
                  v-for="(product, index) in products"
                  :key=" 'product' + index"
                  class="product type-f pt-3 pb-3"
                  :class="{ 'align-column' : navOption.optionLayout == 1}"
                >
                  <div class="product__block-1">
                    <div class="thumb">
                      <img v-if="product.images[0]" :src="[product.images[0].url]">
                      <img v-else src="../assets/img/default-noimg.png">
                    </div>
                  </div>
                  <div class="product__block-2">
                    <div>
                      <h5
                        class="ui text large-lg medium-md tiny-sm tiny semibold mb-1 mt-1"
                      >{{product.titleTH}}</h5>
                      <p
                        class="ui text large-lg medium-md tiny-sm tiny bold [ color red-2 ] mb-0 mt-0"
                      >{{currency}}{{formatPrice(product.netPrice)}}</p>
                      <p
                        v-if="product.netPrice != product.price"
                        class="ui text large-lg medium-md tiny-sm tiny light line-through m-0 mb-1"
                      >{{currency}}{{formatPrice(product.price)}}</p>
                    </div>
                    <div class="d-flex align-items-center ml-auto">
                      <AddToCart
                        v-if="product.quantity != 0"
                        :btnStyle="'style2'"
                        :product="product"
                      />
                      <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                      <Favorite :productId="product.id" :type="2"></Favorite>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="col-12 text-center">Loading...</div>
              </div>
            </div>
            <Pagination v-if="!loading" :currentPage="currentPage" :lastPage="lastPage"></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategory from "@/components/products/ProductCategory.vue";
import ProductOption from "@/components/products/ProductOption.vue";
import AddToCart from "@/components/cart/AddItem.vue";
import Favorite from "@/components/favorite/AddFavorite.vue";
import Pagination from "@/components/products/Pagination.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import _ from "lodash";
import { type } from "os";

export default {
  name: "product",
  components: {
    ProductCategory,
    ProductOption,
    AddToCart,
    Pagination,
    Favorite
  },
  data() {
    return {
      products: [],
      navOption: {
        name: "",
        amount: 0,
        optionLayout: 1,
        optionPrice: 1
      },
      categoryName: "",
      loading: true,
      currency: "",
      page: 1,
      fromPage: 1,
      currentPage: 1,
      lastPage: 1
    };
  },
  created() {
    this.currency = this.$parent.currency;
    this.navOption.optionPrice = localStorage.getItem("optionPrice")
      ? localStorage.getItem("optionPrice")
      : 1;
    this.navOption.optionLayout = localStorage.getItem("optionLayout")
      ? localStorage.getItem("optionLayout")
      : 1;
    this.getProduct();
  },
  computed: {
    optionPrice() {
      return this.navOption.optionPrice;
    }
  },
  methods: {
    getProduct() {
      this.loading = true;
      if (this.navOption.name != this.$parent.search) {
        this.page = 1;
      }
      this.navOption.name = this.$parent.search;

      let data = {
        orderBy: this.navOption.optionPrice == 1 ? "low" : "",
        search: this.$parent.search,
        page: this.page
      };
      this.$http
        .get("products", { params: data })
        .then(response => {
          this.products = response.data.data;
          this.navOption.amount = response.data.amount;
          this.currentPage = response.data.meta.current_page;
          this.lastPage = response.data.meta.last_page;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
    detailItem(item, event) {
      if (
        !event.target.classList.contains("addcart") &&
        !event.target.classList.contains("favorite")
      ) {
        this.$router.push("/products/item/" + item.id);
      }
    },
    formatPrice(value) {
      let price = Number(value);
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  watch: {
    categoryName(val) {
      this.$parent.search = val;
    },
    optionPrice() {
      this.getProduct();
    },
    "$route.query.search"() {
      this.getProduct();
    },
    page(val) {
      this.getProduct();
    }
  }
};
</script>

